import { render, staticRenderFns } from "./OppositeLang.vue?vue&type=template&id=bf9e6030&scoped=true&lang=pug&"
import script from "./OppositeLang.vue?vue&type=script&lang=js&"
export * from "./OppositeLang.vue?vue&type=script&lang=js&"
import style0 from "./OppositeLang.vue?vue&type=style&index=0&id=bf9e6030&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9e6030",
  null
  
)

export default component.exports